const hotMiddlewareScript = require('webpack-hot-middleware/client?noInfo=true&timeout=20000&reload=true');

hotMiddlewareScript.subscribe(event => {
  if (event.action === 'reload') {
    window.location.reload();
  }
});



// WEBPACK FOOTER //
// resources/assets/build/helpers/hmr-client.js